import React, { useEffect, useState } from 'react'
import { nanoid } from 'nanoid'

const comercialDocuments = [
    { 
        id: 1,
        title: 'RECIBOS',
        type: 'VN',
    },
    {
        id: 2,
        title: 'NOTA DE DÉBITOS',
        type: 'ND'
    }
]

export default function TabsTitleButttons({ inititalTab = 0, onChange = () => {} }) {

  const [currentTab, setCurrentTab] = useState(inititalTab);

  const changeTab = (value) => {
    setCurrentTab(value);
  }

  useEffect(() => {
    onChange(comercialDocuments[currentTab].type);
  },[currentTab])

  return (
    <>
        <div className="tabs-container">
        {comercialDocuments.map((item , index) => {
            return <div 
                        onClick={() => changeTab(index)} 
                        key={nanoid()} 
                        className={`tab-button-title ${index === currentTab && 'tab-button-title-active'}`}
                    >
                        {item.title} ({item.type})
                    </div>
        })}
        </div>
        <div className="row mt-3">
            <div className="col">
                <h4>{comercialDocuments[currentTab].title} ({comercialDocuments[currentTab].type})</h4>
            </div>
        </div>
    </>
  )
}
